<ng-container *ngFor="let language of supportedLanguages">
  <a (click)="onChangeLanguage(language)" class="language-item"
    [ngClass]="{'selected': isCurrentlySelectedLanguage(language)}">{{ language }}</a>
</ng-container>
